export default "__VITE_ASSET__392acf90__"